import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./agent-trio.scss";
import {CommunityAgentScope} from "../types/CommunityAgentScope";
import {AgentAvatarComponent} from "../avatar/AgentAvatarComponent";
import {AgentAvatarBody} from "../avatar/AgentAvatarBody";
import {AgentAvatarState} from "../avatar/types/AgentAvatarState";
import {AgentFaceUpgrader} from "../avatar/AgentFaceUpgrader";

// les visages de l'équipe au repos : celui du milieu passe devant
const TEAM = [CommunityAgentScope.PERSONA_REMI, CommunityAgentScope.PERSONA_ALYA, CommunityAgentScope.PERSONA_MARC];
// part de chaque emplacement que remplit le corps de l'agent
const FILL = 0.92;

/**
 * L'icône des conversations : trois agents en photo de groupe, au repos. Dans le menu, le trio reste calme : une
 * réponse qui attend d'être lue ne s'y signale pas, elle se retrouve dans les conversations.
 */
export class AgentTrioComponent extends Component {

    constructor() {
        super();

        //language=HTML
        this.template = `
            <div class="${s.componentAgentTrio}">
                <div class="${s.slot} ${s.left}"></div>
                <div class="${s.slot} ${s.right}"></div>
                <div class="${s.slot} ${s.front}"></div>
            </div>
        `;

        this.onCommit(() => {
            const state = AgentFaceUpgrader.stateOf(this.getHTMLElement());
            this.place(this.el(s.left), TEAM[0], state);
            this.place(this.el(s.right), TEAM[2], state);
            this.place(this.el(s.front), TEAM[1], state);
        });
    }

    private place(slot: Component, persona: number, state: AgentAvatarState): void {
        const fit = AgentAvatarBody.fit(AgentAvatarBody.identity(persona), FILL);
        const face = slot.append(`<div class="${s.face}"></div>`);
        face.setStyle(`transform:translate(${(fit.shiftX * 100).toFixed(1)}%,${(fit.shiftY * 100).toFixed(1)}%) scale(${fit.scale.toFixed(3)});`);
        const avatar = new AgentAvatarComponent({persona: persona, state: state});
        face.render(avatar);
        AgentFaceUpgrader.register(slot.getHTMLElement(), avatar);
    }
}
